<template>
    <div
            class="modal fade"
            id="myModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    <h4 class="modal-title" id="myModalLabel">高级搜索</h4>
                </div>
                <!-- modal-body-->
                <div class="modal-body">
                    <form id="sys_dlg_formdown" role="form" class="form-horizontal">
                        <div class="form-group">
                            <label class="col-sm-2 control-label">局方合同起止起始时间：</label>
                            <div class="col-sm-4">
                                <input
                                        id="stst_commcontractstar_start"
                                        type="text"
                                        class="form-control"
                                        v-model="data.stst_commcontractstar_start"
                                        @click="datePicker('stst_commcontractstar_start')"
                                />
                            </div>
                            <label class="col-sm-2 control-label">局方合同起止结束时间：</label>
                            <div class="col-sm-4">
                                <input
                                        id="stst_commcontractstar_end"
                                        type="text"
                                        class="form-control"
                                        v-model="data.stst_commcontractstar_end"
                                        @click="datePicker('stst_commcontractstar_end')"
                                />
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">局方合同终止起始时间：</label>
                            <div class="col-sm-4">
                                <input
                                        id="stst_commcontractend_start"
                                        type="text"
                                        class="form-control"
                                        v-model="data.stst_commcontractend_start"
                                        @click="datePicker('stst_commcontractend_start')"
                                />
                            </div>
                            <label class="col-sm-2 control-label">局方合同终止结束时间：</label>
                            <div class="col-sm-4">
                                <input
                                        id="stst_commcontractend_end"
                                        type="text"
                                        class="form-control"
                                        v-model="data.stst_commcontractend_end"
                                        @click="datePicker('stst_commcontractend_end')"
                                />
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">运营商：</label>
                            <div class="col-sm-4">
                                <select id="stst_comm" type="text" class="chosen-select">
                                    <option value="">&nbsp;</option>
                                    <option value="中国移动">中国移动</option>
                                    <option value="中国联通">中国联通</option>
                                    <option value="中国电信">中国电信</option>
                                    <option value="中国铁塔">中国铁塔</option>
                                </select>
                            </div>
                            <label class="col-sm-2 control-label">分管运营商</label>
                            <div class="col-sm-4">
                                <input id="stst_subcomm" type="text" v-model="data.stst_subcomm" class="form-control">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">行政分区</label>
                            <div class="col-sm-4">
                                <input id="stst_area" type="text" v-model="data.stst_area" class="form-control"/>
                            </div>
                            <label class="col-sm-2 control-label">代谈公司：</label>
                            <div class="col-sm-4">
                                <input id="stst_proxytalksid" v-model="data.stst_proxytalksid" type="text"
                                       class="form-control"/>
                            </div>
                        </div>
                    </form>
                </div>
                <!-- ./ modal-body  在此传入html-->
                <div class="modal-footer">
                    <button type="button" data-dismiss="modal" class="btn btn-default">关闭</button>
                    <button type="button" data-dismiss="modal" class="btn btn-primary" @click="search">搜索</button>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
</template>

<script>
  export default {
    data () {
      return {
        data: {
          stst_comm: '',
          stst_commcontractstar_start: '',
          stst_commcontractstar_end: '',
          stst_commcontractend_start: '',
          stst_commcontractend_end: '',
          stst_subcomm: '',
          stst_area: '',
          stst_proxytalksid: '',
        }
      }
    },
    mounted: function () {
      var self = this
      $('.chosen-select').chosen({
        disable_search_threshold: 10,
        disable_search: true,
        width: '100%',
      }).change(function () {
        self.data.stst_comm = $('.chosen-select').val()
        console.log(self.data.stst_comm)
      })
    },
    methods: {
      datePicker: function (elementId) {
        let self = this
        WdatePicker({
          el: elementId,
          dateFmt: 'yyyy-MM-dd',//日期格式，可以只显示年或年月，也可以额外显示时间
          onpicked: function () {
            var value = $('#' + elementId).val()
            self.data[elementId] = value
            console.log(elementId, '----', self.data[elementId])
          },
          oncleared: function () {
            self.data[elementId] = null
          },
          isShowClear: true,
          readOnly: true
        })
      },
      // 搜索
      search: function () {
        let self = this
        console.log(self.data)
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/views/stationmanager/advancedSearch.vue